export const getExportToRefresh = state => state.refreshStateforExport;
export const getFilters = (userId, state) =>
  state[userId]?.filters || state.filters;
export const getDateOption = (userId, state) =>
  state[userId]?.dateOption || state.dateOption;
